import { Injectable } from '@angular/core';

@Injectable()

export class PersonalInformationService {
  validationMessages: any;
  formErrors = {
    firstName: '',
    middleName: '',
    lastName: '',
    personalEmail: '',
    personalEmails: '',
    phonesHome: {
      phoneNumberHome: ''
    },
    phonesCell: {
      phoneNumberCell: ''
    },
    homeStreetAddress: '',
    homeStreetAddress2: '',
    homeCountry: '',
    homeCity: '',
    homeState: '',
    homeZip: '',
    isAddressSame: '',
    mailStreetAddress: '',
    mailStreetAddress2: '',
    mailCountry: '',
    mailCity: '',
    mailState: '',
    mailZip: '',
    permaResiStatus: ''
  };

  textMin = 3;
  titleMax = 50;
  dateMax = 50;
  timeMax = 50;
  descMax = 2000;
  dateFormat = 'd/m/yyyy';
  timeFormat = 'h:mm AM/PM';
  phoneLength = 10;

  noSpaces  = /^[^\s]+(\s+[^\s]+)*$/;
  noSpacesPassword = /[a-zA-Z0-9]+(?:(?:\. |[' ])[a-zA-Z0-9]+)*/;
  emailValidate  = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  phoneValidate  = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  zipValidate = /(^\d{5}(?:[-\s]\d{4})?$)/;

  constructor() {
    this.validationMessages = {
      firstName: {
        required: 'First Name is <strong>required</strong>',
        minlength: `First Name must be ${this.textMin} characters or more.`,
        maxlength: `First Name must be ${this.titleMax} characters or less.`,
        pattern: 'First Name format is not correct',
      },
      middleName: {
        minlength: `Middle Name must be ${this.textMin} characters or more.`,
        maxlength: `Middle Name must be ${this.titleMax} characters or less.`,
        pattern: 'First Name format is not correct',
      },
      lastName: {
        required: 'Last Name is <strong>required</strong>',
        minlength: `Last Name must be ${this.textMin} characters or more.`,
        maxlength: `Last Name must be ${this.titleMax} characters or less.`,
        pattern: 'First Name format is not correct',
      },
      personalEmail: {
        required: 'Personal Email is <strong>required</strong>',
        maxlength: `Personal Email must be ${this.titleMax} characters or less.`,
        pattern: 'Personal Email format is not correct',
      },
      personalEmails: {
        maxlength: `Personal Email must be ${this.titleMax} characters or less.`,
        pattern: 'Personal Email format is not correct',
      },
      phoneNumberHome: {
        length: `Phone Number must be exact 10 numbers.`,
        pattern: 'Phone Number format is not correct',
      },
      phoneNumberCell: {
        length: `Phone Number must be exact 10 numbers.`,
        pattern: 'Phone Number format is not correct',
      },
      homeStreetAddress: {
        required: 'Street Address is <strong>required</strong>',
        maxlength: `Street Address must be ${this.titleMax} characters or less.`,
        pattern: 'Street Address format is not correct',
      },
      homeStreetAddress2: {
        maxlength: `Address must be ${this.titleMax} characters or less.`,
        pattern: 'Address format is not correct',
      },
      homeCountry: {
        required: 'Country is <strong>required</strong>',
      },
      homeCity: {
        required: 'City is <strong>required</strong>',
        pattern: 'City format is not correct',
      },
      homeState: {
        required: 'State is <strong>required<strong>'
      },
      homeZip: {
        required: 'Zip is <strong>required</strong>',
        minlength: `Zip must be ${this.textMin} numbers or more.`,
        maxlength: `Zip must be ${this.titleMax} numbers or less.`,
        pattern: 'Zip format is not correct',
      },
      isAddressSame: {
        required: 'This Field is <strong>required</strong>',
      },
      mailStreetAddress: {
        required: 'Street Address is <strong>required</strong>',
        maxlength: `Street Address must be ${this.titleMax} characters or less.`,
        pattern: 'Street Address format is not correct',
      },
      mailStreetAddress2: {
        maxlength: `Street Address must be ${this.titleMax} characters or less.`,
        pattern: 'Street Address format is not correct',
      },
      mailCountry: {
        required: 'Country is <strong>required</strong>',
      },
      mailCity: {
        required: 'City is <strong>required</strong>',
      },
      mailState: {
        required: 'State is <strong>required<strong>'
      },
      mailZip: {
        required: 'Zip is <strong>required</strong>',
        minlength: `Zip must be ${this.textMin} numbers or more.`,
        maxlength: `Zip must be ${this.titleMax} numbers or less.`,
        pattern: 'Zip format is not correct',
      },
      permaResiStatus: {
        required: 'This Field is <strong>required</strong>',
      }
    };

  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/personal-information/personal-information.service.ts